import request from 'superagent'
import { authArgs, region, url as baseURL } from '@/libs/api'

export default ({ namespace, url, method, token }) => {
  const req = request[method](url).use(baseURL(`api-${region}-${namespace}`))
  return token ? req.set(...authArgs(token)) : req
}
